module.exports = __webpack_public_path__ + "static/media/Drowzee_gaussian2.f2de5e06.png";